export default __webpack_public_path__ + "static/media/fablab3.87e4cc5b.jpg";